<template>
  <Layout :footer-style="2">
    <div class="Information">
      <div class="Information_content" id="Information_content">
        <StaticBanner :banner-date="bannerDate"></StaticBanner>
        <dropdownMenu :pkname="'最新资讯'" :pktype="'information'"></dropdownMenu>
        <div class="titles" v-if="windowWidth > 767">
          <div class="in_titles">
            <div class="in_titles_left">
              <img class="in_titles_left_img" src="../assets/images/industry/tb.png" alt="" />
              <div><span style="margin-right: 10px">&gt;</span><span style="font-size: 18px">最新资讯</span></div>
            </div>
            <div class="in_titles_right">
              <a :class="val == '1' ? 'changes' : ''" @click="titleRouter('about', '1')">公司介绍</a>
              <a :class="val == '2' ? 'changes' : ''" @click="titleRouter('about', '2')">历史沿革</a>
              <a :class="val == '3' ? 'changes' : ''" @click="titleRouter('about', '3')">荣誉与资质</a>
              <a :class="val == 'parent' ? 'changes' : ''" @click="titleRouter('parent')">生态伙伴</a>
              <a :class="val == '4' ? 'changes' : ''" @click="titleRouter('about', '4')">加入我们</a>
              <a :class="val == 'info' ? 'changes' : ''" @click="titleRouter('info')">最新资讯</a>
            </div>
          </div>
        </div>
        <div class="content_body container">
          <InformationList :information-datas="InformationData"></InformationList>
          <div class="pagination">
            <paginations @getData="getData" :current="4"></paginations>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style lang="scss">
.Information {
  margin: 0 auto;
  max-width: 1920px;
  .Information_content {
    margin-top: 80px;
    .titles {
      display: flex;
      justify-content: center;
      align-items: center;
      background: #f6f7fa;
      color: #12294f;
      .in_titles {
        display: flex;
        max-width: 1440px;
        height: 70px;
        width: 100%;
        padding: 0 70px;
        align-items: center;

        .in_titles_left {
          display: flex;
          width: 50%;
          align-items: center;
          margin-left: 5%;
          .in_titles_left_img {
            height: 30%;
            margin-right: 10px;
          }
        }
        .in_titles_right {
          display: flex;
          flex: 1;
          justify-content: space-around;
          a {
            color: #12294f;
            padding: 20px 0;
            cursor: pointer;
          }
          .changes {
            border-bottom: 3px solid #005bab;
          }
        }
      }
    }
    .content_body {
      .pagination {
        margin: 3% auto;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
<script>
import Layout from "../components/common/Layout"
import StaticBanner from "@/components/common/staticBanner/index.vue"
import InformationList from "@/components/common/InformationList/index.vue"
import paginations from "@/components/common/paginations/index.vue"
import dropdownMenu from "@/components/common/dropdownMenu.vue"
export default {
  name: "Information",
  components: { StaticBanner, InformationList, Layout, paginations, dropdownMenu },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth,
      bannerDate: {
        url: require("@/assets/images/aboutUs/Information-banner.png"),
        title: "博信诚最新资讯",
        content: "关注博信诚，了解行业趋势及公司最新动向",
        btn: false,
      },
      // InformationDatas:[],
      // InformationDatas: [
      //   {
      //     url: require("@/assets/images/aboutUs/0-元宵节-小图.jpg"),
      //     title: "博信诚祝大家元宵快乐，合家团圆",
      //     font: "博信诚祝大家元宵快乐，合家团圆",
      //     data: "2023/2/6",
      //     tag: "数智化平台",
      //     link: "/information-details/1",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/1.新版网站上线通知.jpg"),
      //     title: "博信诚公司新版官网上线啦！",
      //     font: " 博信诚公司新版官网上线啦！",
      //     data: "2023/2/2",
      //     tag: "数智化平台",
      //     link: "/information-details/2",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/2.权威解读.jpg"),
      //     title: "【转发】国务院国资委权威解读中央企业“一利五率”经营指标体系",
      //     font: " 《国资报告》2023年第1期刊发国资委党委委员、副主任袁野的署名文章《优化中央企业经营指标体系 推动加快实现高质量发展》，权威解析优化调整后的中央企业“一利五率”经营指标体系和2023年“一增一稳四提升”年度经营目标。本文为全文分享。",
      //     data: "2023/2/2",
      //     tag: "数智化平台",
      //     link: "/information-details/3",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/3.客户感谢信.jpg"),
      //     title: "来自中国有色工程有限公司客户的感谢信！",
      //     font: " 来自中国有色工程有限公司客户的感谢信！",
      //     data: "2023/1/13",
      //     tag: "数智化平台",
      //     link: "/information-details/4",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/InformationCard-1.png"),
      //     title: "博信诚荣获“2022中国业财一体化云服务领航企业”",
      //     font: " 未来，博信诚将专注于企业云服务领域的创新与探索，数字经济赋能构建新发展格局，持续深耕企业智慧业财产品及解决方案，专注为中高端客户提供全场景、一站式的智慧业财一体化服务，助力企业可持续发展，推动业务增长和盈利能力",
      //     data: "2022/11/03",
      //     tag: "数智化平台",
      //     link: "/information-details/5",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/InformationCard-2.png"),
      //     title: "博信诚荣获“2021中国企业上云数智化平台服务领军企业”",
      //     font: " 赛迪网在峰会上重磅发布了《2021行业信息化竞争力百强》名单，博信诚公司荣耀上榜，被授予“2021中国企业上云数智化平台服务领军企业”称号，以此肯定博信诚公司致力于智慧企业云服务打造企业一体化应用平台，助力企业规模化发展，帮助企业数智化转型做出的努力和成果",
      //     data: "2021/10/07",
      //     tag: "数智化平台",
      //     link: "/information-details/6",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/InformationCard-3.png"),
      //     title: "博信诚-“数智财务 共享未来” 2021集团财务数智化转型管理精品沙龙成功举办",
      //     font: "基于互联网化的新经济视角下，企业数智化管理势在必行，努力把握好企业财务管理者的职责与使命，积极应对互联网经济对企业财务管理的深刻影响，综合运用智能化技术，不断提升现代企业管理水平，数智化财务管理，未来可期！",
      //     data: "2021/04/17",
      //     tag: "数智化平台",
      //     link: "/information-details/7",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/InformationCard-4.png"),
      //     title: "博信诚-“数智财务 共享未来” 精品沙龙诚邀您参加！",
      //     font: "博信诚-“数智财务 共享未来” 精品沙龙诚邀您参加！",
      //     data: "2021/04/06",
      //     tag: "数智化平台",
      //     link: "/information-details/8",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/InformationCard-5.png"),
      //     title: "博信诚荣获“2019中国企业财务共享平台首选品牌厂商”奖",
      //     font: "后疫情时代机遇与挑战并存，随着区块链、数字化、智能技术等深化应用，企业财务管理的变革势在必行，企业的财务负责人、领导者更会高度愈加重视提高企业对数据处理的敏锐度和敏感性，加速转变传统的财务管理理念，重视财务管理职能，提高工作效率，降本增效，实现数智化财务管理",
      //     data: "2020/11/10",
      //     tag: "数智化平台",
      //     link: "/information-details/9",
      //   },
      //   {
      //     url: require("@/assets/images/aboutUs/InformationCard-6.png"),
      //     title: "博信诚作为实施商得到中国国旅集团高度评价",
      //     font: "博信诚作为实施商得到中国国旅集团高度评价",
      //     data: "2020/11/10",
      //     tag: "数智化平台",
      //     link: "/information-details/10",
      //   },
      // ],
      //总数据
      InformationData: [], //经分页处理过的展示的数据数组
      val: "info",
      newsData:[],
    }
  },
  mounted() {
  },
  methods: {
    
    //分页子组件传回来的展示的数组
    getData(data) {
      this.InformationData = data
    },
    titleRouter(type, val) {
      if (type == "about") {
        sessionStorage.setItem("a-id", val)
        this.$router.push({
          path: "/about-us",
        })
      }
      if (type == "parent") {
        this.$router.push({
          path: "/join-partners",
        })
      }
      // aid.classList.remove('change')
      // id.classList.add('change')
    },
  },
}
</script>
